import Forget from './Forget/Forget.store';
import Reset from './Reset/Reset.store';

export default {
  namespaced: true,
  modules: {
    Forget,
    Reset,
  },
};
